export default __webpack_public_path__ + "static/media/newsletter-2023.ee1cb794.png";